var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 16.5H22.8V11.4328C22.8 10.8375 22.6088 10.2656 22.2713 9.84375L18.525 5.16094C18.1875 4.73906 17.73 4.5 17.2538 4.5H15.6V2.25C15.6 1.00781 14.7938 0 13.8 0H1.8C0.80625 0 0 1.00781 0 2.25V17.25C0 18.4922 0.80625 19.5 1.8 19.5H2.4C2.4 21.9844 4.0125 24 6 24C7.9875 24 9.6 21.9844 9.6 19.5H14.4C14.4 21.9844 16.0125 24 18 24C19.9875 24 21.6 21.9844 21.6 19.5H23.4C23.73 19.5 24 19.1625 24 18.75V17.25C24 16.8375 23.73 16.5 23.4 16.5ZM6 21.75C5.00625 21.75 4.2 20.7422 4.2 19.5C4.2 18.2578 5.00625 17.25 6 17.25C6.99375 17.25 7.8 18.2578 7.8 19.5C7.8 20.7422 6.99375 21.75 6 21.75ZM18 21.75C17.0063 21.75 16.2 20.7422 16.2 19.5C16.2 18.2578 17.0063 17.25 18 17.25C18.9938 17.25 19.8 18.2578 19.8 19.5C19.8 20.7422 18.9938 21.75 18 21.75ZM21 12H15.6V6.75H17.2538L21 11.4328V12Z",
    fill: "#28A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTruck);
export default __webpack_public_path__ + "static/media/ic_truck.17dd594605fa7f05897ee2a55bdaed36.svg";
export { ForwardRef as ReactComponent };